import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import WhySwia from "../components/sections/WhySwia";
import Services from "../components/sections/Services";
import Process from "../components/sections/Process";
import Testimonials from "../components/sections/Testimonials";
import FinalCTA from "../components/sections/FinalCTA";
import Carriers from "../components/sections/Carriers";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Home() {
  useScrollReveal();
  return (
    <div data-testid="page-home" className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <Carriers />
        <WhySwia />
        <Services />
        <Process />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
